import { isGitHubAppEnabled } from "~/areas/configuration/components/Git/getGitHubAppSettings";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";

export function useGitHubConnectionRepositorySourcingEnabled() {
    return useOctopusFeatureToggle("githubapp-git-resources", false) && isGitHubAppEnabled();
}
